import { get } from 'lodash'
import defaultConfig from './defaultConfig'
import dev from './dev'
import uat from './uat'
import prod from './prod'
import research from './research'

const configMapper = {
  dev,
  uat,
  prod,
  research,
}

export default {
  ...defaultConfig,
  ...configMapper[get(process.env, 'REACT_APP_ENV', '').trim()]
}
